import React, { useState } from 'react';
import { Menu } from 'antd';
import Terminal from 'terminal-in-react';
import './index.css'
import './style.css';
import IPConfigPage from './IPConfigPage';
import Browser from './Browser';

// 终端
const ComputerTerminal = (props) => {
  const { node, device, style } = props;
  return (
    <div 
      style={{
        width: '1014px',
        height: '422px',    
        background: '#070707',
        minWidth: '1014px',
        minHeight: '422px', 
        ...style,
      }}>
          <Terminal
            color='white'
            prompt="white"
            outputColor="white"
            backgroundColor='black'
            barColor='black'
            msg="Yopu Linux Version 1.00"
            style={{ fontWeight: "bold", fontSize: "16px", width: '1020px', height: '422px'}}
            descriptions={{ ping:'ping host' }}
            hideTopBar={true}
            startState='maximised'
            allowTabs={false}
            promptSymbol={`root@${node.attrs.text.text}:/#`}
            commands={{
              ping: {
                method: (args, print, runCommand) => {
                  const input = args._[0] || []

                  if (input.length === 0) {
                    print(`usage: ping host`)
                    return 
                  } 

                  device.ICMP_ping(input, (response) => {
                    if (response.result !== 'success'){
                      print(`ping: cannot resolve ${input}: Unknown host`)
                      return
                    }

                    const { data, TTL, fromIP } = response.packet;
                    print(`64 bytes from ${fromIP}: icmp_seq=${data} ttl=${TTL} success!`)
                  })
                },
              }
            }}
            commandPassThrough={(cmd, print) => {                     
              print(`${cmd}: command not found`);
            }}
          />
        </div> 
  )
}

export const PC = (props) => {
  const [menuKey, setMenuKey] = useState('配置')

  return (
    <div>
      <div className="computerPage">
        <div 
          style={{
            padding: '10px',
            borderRadius: '20px',
            backgroundColor: '#ecf3fb',
            width: '1040px',
            height: '540px',
            margin: '20px auto',
          }}
        >
          <Menu className="computerMenu" onClick={(e) => setMenuKey(e.key)} selectedKeys={[menuKey]} defaultSelectedKeys={['配置']} mode="horizontal">
            <Menu.Item key="配置" className="computerMenuItem">
              配置
            </Menu.Item>
            <Menu.Item key="命令行" className="computerMenuItem">
              命令行
            </Menu.Item>
            <Menu.Item key="浏览器" className="computerMenuItem">
              浏览器
            </Menu.Item>
          </Menu>
          <hr style={{color: '#D5DDE5'}} />
          <IPConfigPage {...props} layoutMode="two" style={{ display: menuKey === '配置' ? 'block': 'none' }} />
          <ComputerTerminal  {...props} style={{ display: menuKey === '命令行' ? 'block': 'none' }} />
          <Browser {...props} style={{ display: menuKey === '浏览器' ? 'block': 'none' }} />
        </div>
      </div>
      <div style={{
        width: '180px',
        height: '100px',
        backgroundColor: '#121c1e',
        margin: '0 auto',
      }}></div>
      <div 
      style={{
        width: '370px',
        height: '40px',
        backgroundColor: '#458eec',
        margin: '0 auto',
      }}></div>
    </div>
  );
};

